/**
 * WineNot — Validación de carrito
 * Reglas:
 *  - Mínimo 6 botellas en total
 *  - Cantidad total debe ser múltiplo de 6
 */

(function () {
  const MIN_BOTTLES = 6;
  const MULTIPLE_OF = 6;

  const MSG_MINIMUM = `Mínimo de compra: ${MIN_BOTTLES} botellas. Por favor agregá más productos al carrito.`;
  const MSG_MULTIPLE = `Las botellas se envían en cajas de ${MULTIPLE_OF}. Tu cantidad total debe ser múltiplo de ${MULTIPLE_OF} (6, 12, 18, 24...). Ajustá tu carrito para continuar.`;

  const ERROR_STYLES = `
    .winenot-error {
      background: #fef2f2;
      border: 1px solid #dc2626;
      border-radius: 6px;
      color: #dc2626;
      font-size: 14px;
      font-weight: 500;
      margin: 12px 0;
      padding: 12px 16px;
      text-align: center;
    }
    #winenot-drawer-error {
      display: none;
      margin: 8px 0;
    }
  `;

  const styleTag = document.createElement('style');
  styleTag.textContent = ERROR_STYLES;
  document.head.appendChild(styleTag);

  // Calcular total de botellas
  function getTotalBottles() {
    const quantities = document.querySelectorAll(
      '.quantity__input, input[name="updates[]"], .cart-item__quantity input, cart-drawer .quantity__input'
    );
    let total = 0;
    quantities.forEach(function (input) {
      const val = parseInt(input.value, 10);
      if (!isNaN(val) && val > 0) total += val;
    });
    return total;
  }

  // Validar cantidad
  function getValidationMessage(total) {
    if (total < MIN_BOTTLES) return MSG_MINIMUM;
    if (total % MULTIPLE_OF !== 0) return MSG_MULTIPLE;
    return null;
  }

  // ─── CARRITO PÁGINA COMPLETA ──────────────────────────────
  function showPageError(message) {
    // Usar el div nativo #cart-errors de Shopify
    const cartErrors = document.getElementById('cart-errors');
    if (cartErrors) {
      cartErrors.innerHTML = `<div class="winenot-error" role="alert">${message}</div>`;
      cartErrors.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }

  function hidePageError() {
    const cartErrors = document.getElementById('cart-errors');
    if (cartErrors) cartErrors.innerHTML = '';
  }

  // ─── CARRITO LATERAL (DRAWER) ─────────────────────────────
  function showDrawerError(message) {
    let errorEl = document.getElementById('winenot-drawer-error');
    if (!errorEl) {
      errorEl = document.createElement('div');
      errorEl.id = 'winenot-drawer-error';
      errorEl.className = 'winenot-error';
      errorEl.setAttribute('role', 'alert');

      // Insertar antes del botón de pagar en el drawer
      const drawerCheckout = document.querySelector('cart-drawer [name="checkout"], cart-drawer .cart__checkout-button');
      if (drawerCheckout && drawerCheckout.parentNode) {
        drawerCheckout.parentNode.insertBefore(errorEl, drawerCheckout);
      }
    }
    errorEl.textContent = message;
    errorEl.style.display = 'block';
  }

  function hideDrawerError() {
    const errorEl = document.getElementById('winenot-drawer-error');
    if (errorEl) errorEl.style.display = 'none';
  }

  // ─── LISTENERS ───────────────────────────────────────────

  // 1. Submit del formulario del carrito (página completa)
  document.addEventListener('submit', function (e) {
    const form = e.target;
    if (!form.matches('form[action="/cart"], form#cart')) return;

    const submitter = e.submitter;
    if (submitter && (submitter.name === 'checkout' || submitter.id === 'checkout')) {
      const total = getTotalBottles();
      const msg = getValidationMessage(total);
      if (msg) {
        e.preventDefault();
        e.stopImmediatePropagation();
        showPageError(msg);
      } else {
        hidePageError();
      }
    }
  }, true);

  // 2. Clicks en botones de checkout (drawer y página)
  document.addEventListener('click', function (e) {
    const btn = e.target.closest(
      '[name="checkout"], #checkout, .cart__checkout-button, cart-drawer [name="checkout"]'
    );
    if (!btn) return;

    const total = getTotalBottles();
    const msg = getValidationMessage(total);

    if (msg) {
      e.preventDefault();
      e.stopImmediatePropagation();

      // Determinar si estamos en el drawer o en la página
      const inDrawer = btn.closest('cart-drawer') !== null;
      if (inDrawer) {
        showDrawerError(msg);
      } else {
        showPageError(msg);
      }
    } else {
      hidePageError();
      hideDrawerError();
    }
  }, true);

  // 3. Limpiar error cuando el cliente cambia cantidades
  document.addEventListener('change', function (e) {
    if (!e.target.matches('.quantity__input, input[name="updates[]"]')) return;
    const total = getTotalBottles();
    if (!getValidationMessage(total)) {
      hidePageError();
      hideDrawerError();
    }
  });

  // 4. Re-inicializar si Shopify recarga el carrito dinámicamente
  document.addEventListener('cart:refresh', function () {
    hideDrawerError();
  });

})();